import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { LockOpen } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";

const HANDLES = [
  { id: "success", color: "#4caf50", label: "Desbloqueado" },
  { id: "nao_bloqueado", color: "#2196f3", label: "Nao bloqueado" },
  { id: "error", color: "#f44336", label: "Erro" },
];

const IxcDesbloquearNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<LockOpen />}
      title="IXC: Desbloquear"
      color="#e65100"
      bgColor="#FFF3E0"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={240}
    >
      {/* Variable chip */}
      {data?.idClienteVariable && (
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 9, color: "#888", display: "block", marginBottom: 2 }}>
            ID Cliente
          </span>
          <span style={{
            display: "inline-block",
            fontFamily: "'Fira Mono', 'Consolas', monospace",
            fontSize: 11, background: "#e6510015", color: "#e65100",
            borderRadius: 6, padding: "2px 8px", border: "1px solid #e6510025",
          }}>
            {data.idClienteVariable}
          </span>
        </div>
      )}

      {/* Handle rows at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 4 }}>
        {HANDLES.map((h) => (
          <div key={h.id} style={{
            display: "flex", alignItems: "center", justifyContent: "flex-end",
            gap: 6, position: "relative", paddingRight: 4,
          }}>
            <span style={{
              fontSize: 9, fontWeight: 600, color: "#fff",
              background: h.color, borderRadius: 10,
              padding: "1px 8px", lineHeight: "16px", whiteSpace: "nowrap",
            }}>
              {h.label}
            </span>
            <Handle
              type="source" position={Position.Right} id={h.id}
              className={getHandleClass("source", h.id)}
              style={{
                position: "absolute", top: "50%", right: -13,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </NodeWrapper>
  );
});

IxcDesbloquearNode.displayName = "IxcDesbloquearNode";
export default IxcDesbloquearNode;
